import { UAParser } from 'ua-parser-js'

export function clientDetection(): UAParser.IResult {
  const parser = new UAParser()

  return parser.getResult()
}
